import { Document } from "@prismicio/client/types/documents";

export const linkResolver = (doc: Document) => {
  if (doc.type === "article") {
    return `/blog/article/${doc.uid}`;
  }
  if (doc.type === "page") {
    return `/${doc.uid}`;
  }

  return "/";
};
